import type { HbBidderConfig } from '../types'

export const STARTIO: HbBidderConfig = {
    bidder: 'startio',
    params: {
        publisherId: '173395190',
    },
}
